export default __webpack_public_path__ + "static/media/bootstrap.d180fe4c.svg";